import { RoomReservationReport } from "model/reports/roomReservation.report.model"
import { FilterType } from "model/filter.model"
import { useHTTPClient } from "services/httpClient.service"
import { host } from "config/api.config"
import { RestaurantOccupationReport } from "model/reports/restaurantOccupation.report.model"

const url = `${host}/report`
export function useGetRoomReservationReportApi(){

    const {data, loading, error, get} = useHTTPClient<RoomReservationReport[]>(`${url}/room-reservation`)

    async function getApi(filter?: FilterType){
        if(!filter?.rooms || filter.rooms.length <= 0) return
        const roomsStrings = filter?.rooms?.map(_ => `rooms=${_.id}`)
        const roomString = roomsStrings?.join('&')
        const u = `${url}?startDate=${filter?.startDate?.toISOString()}&endDate=${filter?.endDate?.toISOString()}&${roomString}`
        console.log(u)
        const response = await get({_url: u})
        return response
    }

    return {
        loading,
        error: error,
        get: getApi,
        data
    }
}

export function useGetRoomOccupationReportApi(){

    const {data, loading, error, get} = useHTTPClient<RoomReservationReport[]>(`${url}/room-occupation`)

    async function getApi(filter?: FilterType, validateResponse?: (data: any) => any){
        if(!filter?.rooms || filter.rooms.length <= 0) return
        const roomsStrings = filter?.rooms?.map(_ => `rooms=${_.id}`)
        const roomString = roomsStrings?.join('&')
        const u = `${url}/room-occupation?startDate=${filter?.startDate?.toISOString()}&endDate=${filter?.endDate?.toISOString()}&${roomString}`
        console.log(u)
        const response = await get({_url: u, validateResponse, timeout: 3 * 60 * 1000}) // 3 minutes timeout
        return response
    }

    return {
        loading,
        error: error,
        get: getApi,
        data
    }
}

export function useGetRestauranteOccupationReportApi(){

    const {data, loading, error, get} = useHTTPClient<RestaurantOccupationReport[]>(`${url}/restaurant-occupation`)

    async function getApi(filter?: FilterType, validateResponse?: (data: any) => any){
        if(!filter?.rooms || filter.rooms.length <= 0) return
        const roomsStrings = filter?.rooms?.map(_ => `rooms=${_.id}`)
        const roomString = roomsStrings?.join('&')
        const u = `${url}/restaurant-occupation?startDate=${filter?.startDate?.toISOString()}&endDate=${filter?.endDate?.toISOString()}&${roomString}`
        console.log(u)
        const response = await get({_url: u, validateResponse, timeout: 3 * 60 * 1000}) // 3 minutes timeout
        return response
    }

    return {
        loading,
        error: error,
        get: getApi,
        data
    }
}

export function useGetVisitantesRestauranteReportApi(){

    const {data, loading, error, get} = useHTTPClient<RestaurantOccupationReport[]>(`${url}/visitantes-restaurante`)

    async function getApi(filter?: FilterType, validateResponse?: (data: any) => any){
        if(!filter?.rooms || filter.rooms.length <= 0) return
        const roomsStrings = filter?.rooms?.map(_ => `rooms=${_.id}`)
        const roomString = roomsStrings?.join('&')
        const u = `${url}/visitantes-restaurante?startDate=${filter?.startDate?.toISOString()}&endDate=${filter?.endDate?.toISOString()}&${roomString}`
        console.log(u)
        const response = await get({_url: u, validateResponse, timeout: 3 * 60 * 1000}) // 3 minutes timeout
        return response
    }

    return {
        loading,
        error: error,
        get: getApi,
        data
    }
}

export function useGetRoomOccupationMonthsReportApi(){

    const {data, loading, error, get} = useHTTPClient<string[]>(`${url}/room-occupation-monthly-reports`)

    return {
        loading,
        error,
        get,
        data
    }
}

export function useGetRoomOccupationMonthlyReportFileUrlApi(){
    const {data, loading, error, get} = useHTTPClient<string>(`${url}/room-occupation-monthly`)

    async function getApi(month: string){
        const u = `${url}/room-occupation-monthly?month=${month}`
        const response = await get({_url: u})
        return response
    }

    return {
        loading,
        error,
        get: getApi,
        data
    }
}